import Close from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Snackbar, { SnackbarOrigin } from '@mui/material/Snackbar';
import { FC, useEffect, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { useLocation } from 'react-router';

type AuthSnackbarProps = {
  message: string;
  position: SnackbarOrigin;
};

const AuthSnackbar: FC<AuthSnackbarProps> = ({ message, position }) => {
  const auth = useAuth();
  const { pathname, search } = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => setOpen(!auth.isAuthenticated && !auth.isLoading), [auth]);

  return (
    <Snackbar
      sx={{ pt: 6 }}
      anchorOrigin={position}
      open={open}
      onClose={() => setOpen(false)}
      message={message}
      action={
        <>
          <Button
            variant='text'
            color='primary'
            onClick={(event) => {
              event.preventDefault();
              sessionStorage.setItem('authRedirectUrl', `${pathname}${search}`);
              auth.signinRedirect();
            }}
          >
            Login
          </Button>
          <IconButton size='small' aria-label='close' color='inherit' onClick={() => setOpen(false)}>
            <Close fontSize='small' />
          </IconButton>
        </>
      }
    />
  );
};

export default AuthSnackbar;
